import { Card } from 'antd';
import styled from 'styled-components';

export const NoteCardStyled = styled(Card)`
  margin-bottom: 1rem;
  box-shadow: 0 1px 1px #e0e0e0;
`;

export const MessageStyled = styled.div`
  font-size: 1.2rem;
  margin-bottom: 1rem;
`;

export const NoteInformation = styled.span`
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.5);
`;
